/* IZECOmfort v8 · transiciones, vídeos optimizados, pasos de uso, visor, envío y opiniones */
(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s);};
var $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s));};
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var IO='IntersectionObserver' in window;
var DESIGN=!!(window.Shopify&&Shopify.designMode);
var root=document.documentElement;

/* ---------- Fechas de entrega ---------- */
function addWork(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);if(x.getDay()%6!==0)n--;}return x;}
function fmt(d){return d.toLocaleDateString('es-ES',{weekday:'short',day:'numeric'}).replace('.','');}
function fmtL(d){return d.toLocaleDateString('es-ES',{weekday:'short',day:'numeric',month:'short'}).replace(/\./g,'');}
function hm(h,m){return h>0?h+' h '+m+' min':m+' min';}
function plan(el){
  var cut=+el.dataset.cut||14,mn=+el.dataset.min||1,mx=+el.dataset.max||2,now=new Date();
  var wk=now.getDay()%6===0,late=wk||now.getHours()>=cut,ship=late?addWork(now,1):now;
  var a=addWork(ship,mn),b=addWork(ship,mx),left=cut*60-(now.getHours()*60+now.getMinutes());
  return {late:late,ship:ship,a:a,b:b,h:Math.floor(left/60),m:left%60,same:mn===mx};
}
function paintShip(){
  $$('[data-izc-ship]').forEach(function(el){
    var p=plan(el),line=$('[data-ship-line]',el);if(!line)return;
    var when=p.same?fmt(p.a):fmt(p.a)+' – '+fmt(p.b);
    line.innerHTML=p.late?'Pídelo hoy y llega el <strong>'+when+'</strong>':'Pídelo en <strong>'+hm(p.h,p.m)+'</strong> y llega el <strong>'+when+'</strong>';
  });
  $$('[data-izc-envio]').forEach(function(el){
    var p=plan(el),live=$('[data-izc-live]',el),d1=$('[data-izc-d1]',el),d2=$('[data-izc-d2]',el);
    if(live)live.innerHTML=p.late?'Pídelo ahora y lo recibes '+(p.same?'el <b>'+fmtL(p.a)+'</b>':'entre el <b>'+fmtL(p.a)+'</b> y el <b>'+fmtL(p.b)+'</b>')+'.':'Pide en las próximas <b>'+hm(p.h,p.m)+'</b> y sale hoy de nuestro almacén.';
    if(d1)d1.textContent=p.late?fmt(p.ship):'Hoy';
    if(d2)d2.textContent=p.same?fmt(p.a):fmt(p.a)+' – '+fmt(p.b);
  });
}

/* ---------- Barra de avisos: un aviso cada vez en móvil ---------- */
function bar(){
  $$('[data-izc-bar]').forEach(function(b){
    if(b.dataset.on)return;b.dataset.on='1';
    var it=$$('.izc-bar-item',b);if(it.length<2)return;
    var i=0,ms=(+b.dataset.speed||4)*1000;
    setInterval(function(){
      if(innerWidth>=900||document.hidden)return;
      var cur=it[i];cur.classList.remove('on');cur.classList.add('out');
      setTimeout(function(){cur.classList.remove('out');},600);
      i=(i+1)%it.length;it[i].classList.add('on');
    },ms);
  });
}

/* ---------- Vídeos: cargar al acercarse, reproducir al verse ---------- */
var loadIO=IO?new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){load(e.target);loadIO.unobserve(e.target);}});},{rootMargin:'500px 0px'}):null;
var playIO=IO?new IntersectionObserver(function(en){en.forEach(function(e){var v=e.target;if(e.isIntersecting){load(v);play(v);}else{v.pause();}});},{threshold:.3}):null;
function load(v){if(v.dataset.src&&!v.getAttribute('src')){v.src=v.dataset.src;v.preload='auto';try{v.load();}catch(_){}}}
function play(v){if(RM)return;v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});}
function videos(scope){
  $$('video[data-izc-lazy]',scope).forEach(function(v){
    if(v.dataset.on)return;v.dataset.on='1';
    v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');v.playsInline=true;
    var ready=function(){v.classList.add('is-ready');};
    v.addEventListener('loadeddata',ready);v.addEventListener('playing',ready);
    v.addEventListener('error',function(){if(v.dataset.retry){v.dataset.err='1';return;}v.dataset.retry='1';setTimeout(function(){var s=v.dataset.src;if(!s)return;v.removeAttribute('src');v.src=s;try{v.load();}catch(_){}var r=v.getBoundingClientRect();if(!v.hasAttribute('data-izc-manual')&&r.top<innerHeight&&r.bottom>0)play(v);},700);});
    if(RM){v.controls=true;}
    if(!IO){load(v);if(!v.hasAttribute('data-izc-manual'))play(v);return;}
    loadIO.observe(v);
    if(!v.hasAttribute('data-izc-manual'))playIO.observe(v);
  });
}

/* ---------- Pasos de "Cómo se usa" ---------- */
function how(scope){
  $$('[data-izc-how]',scope).forEach(function(sec){
    if(sec.dataset.on)return;sec.dataset.on='1';
    var steps=$$('[data-izc-how-step]',sec),panes=$$('[data-izc-how-v]',sec),num=$('[data-izc-how-n]',sec);
    if(!steps.length)return;
    var n=steps.length,i=0,vis=false,raf=0,t0=0,dur=(+sec.dataset.dur||5)*1000;
    var vid=function(k){return panes[k]?$('video',panes[k]):null;};
    var barOf=function(k){return $('.izc-how-bar i',steps[k]);};
    function prep(v){if(v)load(v);}
    function tick(t){
      if(!vis)return;var v=vid(i),k;
      if(v&&!v.dataset.err){k=(v.duration&&isFinite(v.duration))?v.currentTime/v.duration:0;}
      else{k=(t-t0)/dur;if(k>=1){go(i+1);return;}}
      var b=barOf(i);if(b)b.style.setProperty('--k',Math.min(1,k).toFixed(4));
      raf=requestAnimationFrame(tick);
    }
    function run(){cancelAnimationFrame(raf);t0=performance.now();var v=vid(i);if(v&&!RM){prep(v);play(v);}raf=requestAnimationFrame(tick);}
    function go(k,user){
      k=(k+n)%n;var old=vid(i);
      if(old&&k!==i){old.pause();try{old.currentTime=0;}catch(_){}}
      steps.forEach(function(s,x){s.setAttribute('aria-selected',x===k?'true':'false');var b=barOf(x);if(b)b.style.setProperty('--k',x<k?1:0);});
      panes.forEach(function(p,x){p.classList.toggle('on',x===k);});
      i=k;if(num)num.textContent=k+1;
      if(vis){prep(vid(k));prep(vid((k+1)%n));run();}
    }
    steps.forEach(function(s,x){s.addEventListener('click',function(){go(x,true);});});
    panes.forEach(function(p,x){var v=$('video',p);if(!v)return;
      v.addEventListener('ended',function(){if(x===i)go(i+1);});
      v.addEventListener('canplay',function(){if(x===i&&vis&&v.paused&&!RM)play(v);});
    });
    if(IO){new IntersectionObserver(function(en){vis=en[0].isIntersecting;if(vis){prep(vid(i));prep(vid((i+1)%n));run();}else{cancelAnimationFrame(raf);var v=vid(i);if(v)v.pause();}},{threshold:.35}).observe(sec);}
    else{vis=true;run();}
    go(0);
  });
}

/* ---------- Visor de vídeo en grande ---------- */
var lb=null,lbItems=[],lbI=0;
function lbBuild(){
  if(lb)return lb;
  lb=document.createElement('div');lb.className='izc-lb8';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Vídeo en grande');
  lb.innerHTML='<div class="izc-lb8-s"></div><button type="button" class="izc-lb8-nav prev" aria-label="Vídeo anterior"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button><div class="izc-lb8-box"><button type="button" class="izc-x" aria-label="Cerrar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><video muted playsinline loop autoplay></video><div class="izc-lb8-cap"></div></div><button type="button" class="izc-lb8-nav next" aria-label="Vídeo siguiente"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>';
  document.body.appendChild(lb);
  $('.izc-lb8-s',lb).addEventListener('click',lbClose);$('.izc-x',lb).addEventListener('click',lbClose);
  $('.prev',lb).addEventListener('click',function(){lbShow(lbI-1);});$('.next',lb).addEventListener('click',function(){lbShow(lbI+1);});
  document.addEventListener('keydown',function(e){if(!lb.classList.contains('on'))return;if(e.key==='Escape')lbClose();if(e.key==='ArrowRight')lbShow(lbI+1);if(e.key==='ArrowLeft')lbShow(lbI-1);});
  var x0=null;var box=$('.izc-lb8-box',lb);
  box.addEventListener('pointerdown',function(e){x0=e.clientX;});
  box.addEventListener('pointerup',function(e){if(x0===null)return;var d=e.clientX-x0;x0=null;if(Math.abs(d)>50)lbShow(lbI+(d<0?1:-1));});
  return lb;
}
function lbShow(k){
  var n=lbItems.length;if(!n)return;lbI=(k+n)%n;var it=lbItems[lbI],src=it.v.dataset.src||it.v.currentSrc||it.v.src;
  var v=$('video',lb);if(v.getAttribute('src')!==src){v.src=src;}v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});
  $('.izc-lb8-cap',lb).textContent=it.cap;
  $$('.izc-lb8-nav',lb).forEach(function(b){b.hidden=n<2;});
}
function lbOpen(fig){
  lbBuild();lbItems=$$('[data-izc-lbitem]').map(function(f){var v=$('video',f);if(!v)return null;var c=$('figcaption',f);return {f:f,v:v,cap:c?c.textContent.trim():''};}).filter(Boolean);
  var k=lbItems.findIndex(function(x){return x.f===fig;});if(k<0)return;
  lb._last=document.activeElement;lb.classList.add('on');document.body.classList.add('izc-lock');lbShow(k);
  setTimeout(function(){$('.izc-x',lb).focus({preventScroll:true});},60);
}
function lbClose(){if(!lb)return;lb.classList.remove('on');document.body.classList.remove('izc-lock');var v=$('video',lb);setTimeout(function(){if(!lb.classList.contains('on'))v.pause();},350);if(lb._last&&lb._last.focus)lb._last.focus({preventScroll:true});}
document.addEventListener('click',function(e){
  var t=e.target.closest&&e.target.closest('[data-izc-lbitem]');if(!t)return;
  if(e.target.closest('a,[data-izc-cod]'))return;
  e.preventDefault();lbOpen(t);
});

/* ---------- Carrusel de opiniones ---------- */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-izc-snap-prev],[data-izc-snap-next]');if(!b)return;
  var row=$('[data-izc-snap]',b.closest('.izc-rv8-rowwrap'));if(!row)return;
  var c=row.firstElementChild,w=c?c.getBoundingClientRect().width+14:300;
  row.scrollBy({left:b.hasAttribute('data-izc-snap-next')?w:-w,behavior:RM?'auto':'smooth'});
});

/* ---------- Cifras que suben ---------- */
function countUp(el){
  if(el.dataset.done)return;el.dataset.done='1';
  var txt=el.textContent,m=txt.match(/(\d+(?:[.,]\d+)?)/);if(!m||RM)return;
  var raw=m[1],dec=(raw.split(/[.,]/)[1]||'').length,sep=raw.indexOf(',')>-1?',':'.',to=parseFloat(raw.replace(',','.'));if(!(to>0))return;
  var pre=txt.slice(0,m.index),post=txt.slice(m.index+raw.length),t0=performance.now(),D=1400;
  (function step(t){var k=Math.min(1,(t-t0)/D),e=1-Math.pow(2,-10*k);if(k>=1)e=1;el.textContent=pre+(to*e).toFixed(dec).replace('.',sep)+post;if(k<1)requestAnimationFrame(step);})(t0);
}

/* ---------- Transiciones al hacer scroll ---------- */
function splitH(h){
  if(h.dataset.split)return;h.dataset.split='1';var i=0;
  [].slice.call(h.childNodes).forEach(function(nd){
    if(nd.nodeType===3){var parts=nd.textContent.split(/(\s+)/),fr=document.createDocumentFragment();
      parts.forEach(function(p){if(!p)return;if(/^\s+$/.test(p)){fr.appendChild(document.createTextNode(p));return;}var s=document.createElement('span');s.className='w';s.style.setProperty('--i',i++);s.textContent=p;fr.appendChild(s);});
      h.replaceChild(fr,nd);}
    else if(nd.nodeType===1){var w=document.createElement('span');w.className='w';w.style.setProperty('--i',i++);h.replaceChild(w,nd);w.appendChild(nd);}
  });
  h.classList.add('is-split');
}
var rvIO=null;
function reveal(){
  $$('#contenido>.shopify-section>section:not(.izc-main)').forEach(function(s){s.classList.add('izc-isle');});
  var els=$$('[data-izc-rv]:not(.is-in)'),isles=$$('.izc-isle:not(.is-in)'),all=isles.concat(els);
  if(RM||!IO||DESIGN){all.forEach(function(e){e.classList.add('is-in');});$$('[data-izc-count]').forEach(countUp);return;}
  var vh=innerHeight;
  all.forEach(function(e){if(getComputedStyle(e).display==='contents'){e.classList.add('is-in');return;}var r=e.getBoundingClientRect();if(r.top<vh*.92&&r.bottom>0)e.classList.add('is-in');});
  $$('.izc-h2').forEach(function(h){var c=h.closest('[data-izc-rv]');if(c&&!c.classList.contains('is-in'))splitH(h);});
  root.classList.add('izc-anim');
  if(!rvIO)rvIO=new IntersectionObserver(function(en){
    var k=0;en.forEach(function(e){if(!e.isIntersecting)return;var t=e.target;
      if(!t.classList.contains('izc-isle'))t.style.setProperty('--rvd',Math.min(k++*0.08,.4)+'s');
      t.classList.add('is-in');rvIO.unobserve(t);
      $$('[data-izc-count]',t).forEach(function(c){setTimeout(function(){countUp(c);},250);});
    });
  },{rootMargin:'0px 0px -10% 0px',threshold:.08});
  all.forEach(function(e){if(!e.classList.contains('is-in'))rvIO.observe(e);else $$('[data-izc-count]',e).forEach(countUp);});
}

/* ---------- Inicio ---------- */
function boot(scope){
  scope=scope||document;
  videos(scope);how(scope);bar();paintShip();
  reveal();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});else boot(document);
setInterval(paintShip,30000);
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
